import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import useAppBarScrollTrigger from 'hooks/useAppBarScrollTrigger';

import Container from 'components/Container';
import { Topbar, Sidebar, Footer } from './components';

import { useDispatch, useSelector } from 'react-redux';
import AlertPopup from 'components/AlertPopup';
import { hideAlert } from 'redux/slices/alertSlice';
const Minimal = ({ children, bgcolor = 'transparent' }) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const dispatch = useDispatch();
  const [openSidebar, setOpenSidebar] = useState(false);
  const alertState = useSelector((state) => state.alertState);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const open = isMd ? false : openSidebar;

  const trigger = useAppBarScrollTrigger();

  return (
    <Box>
      <AppBar
        position={'sticky'}
        sx={{
          top: 0,
          backgroundColor: trigger ? theme.palette.background.paper : bgcolor,
        }}
        elevation={trigger ? 1 : 0}
      >
        <Container paddingY={1} paddingX={2}>
          <Topbar onSidebarOpen={handleSidebarOpen} />
        </Container>
      </AppBar>
      <Sidebar onClose={handleSidebarClose} open={open} variant="temporary" />
      <main>
        <AlertPopup
          open={alertState.open}
          autoHideDuration={6000}
          handleClose={() => dispatch(hideAlert())}
          message={alertState.message}
          type={alertState.type}
          verticalLocation={alertState.vertical}
          horizontalLocation={alertState.horizontal}
        ></AlertPopup>
        {children}
        <Divider />
      </main>
      <Container paddingY={2}>
        <Footer />
      </Container>
    </Box>
  );
};

Minimal.propTypes = {
  children: PropTypes.node,
  bgcolor: PropTypes.string,
};

export default Minimal;
